"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _moment = _interopRequireDefault(require("moment"));
var _Button = _interopRequireDefault(require("@material-ui/core/Button"));
var _TextInput = _interopRequireDefault(require("Components/Forms/Elements/TextInput"));
var _Checkbox = _interopRequireDefault(require("Components/Forms/Elements/Checkbox"));
var _Select = _interopRequireDefault(require("Components/Forms/Elements/Select"));
var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));
var _getFormStatus = _interopRequireDefault(require("Components/Forms/Functions/getFormStatus"));
var _Modal = _interopRequireDefault(require("Modals/ModalComponent/Modal"));
var _Loader = _interopRequireDefault(require("Pure/Loader"));
var _options = _interopRequireDefault(require("Shared/options"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
class AccountStatusModal extends _react.Component {
  state = {
    send_mail: false,
    status_messages: {},
    warning: undefined,
    loading: false,
    info: undefined,
    comment_status: ""
  };
  handleChange = _ref => {
    let {
      e,
      value,
      name
    } = _ref;
    const component = this,
      props = this.props,
      state = this.state;
    let status_messages = state.status_messages;
    delete status_messages[name];
    component.setState({
      [name]: value,
      error: undefined,
      status_messages: status_messages
    });
  };
  handleOk = e => {
    const component = this,
      props = this.props,
      state = this.state;
    let monitoring_account_status = props.monitoring_account_status;
    monitoring_account_status.push({
      send_date: (0, _moment.default)().format('YYYY-MM-DD'),
      status: state.chosen_status,
      comment: state['comment_status']
    });
    props.onAccountChange(monitoring_account_status);
    props.onChange({
      value: state.chosen_status,
      name: 'candidate[account_status]'
    }), component.sendAccountComment(monitoring_account_status);
    component.setState({
      'comment_status': undefined,
      send_mail: false,
      warning: undefined,
      error: undefined
    });
    props.onClose();
  };
  handleClose = e => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      'comment_status': undefined,
      warning: undefined,
      error: undefined,
      info: undefined,
      send_mail: false
    });
    if (props.onClose) props.onClose();
  };
  sendAccountComment = monitoring_account_status => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      loading: true
    });
    qwest.post('/candidate/send-account-comment', {
      account_status: state.chosen_status,
      comment: state['comment_status'],
      candidate_id: props.candidate_id,
      send_mail: state.send_mail,
      monitoring_account_status: monitoring_account_status
    }).then(function (xhr, response) {
      component.setState({
        loading: false,
        info: response.info
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...getErrorsFromResponse({
          response: response
        })
      });
    });
  };
  handleCheckboxChange = _ref2 => {
    let {
      e,
      name,
      value
    } = _ref2;
    const component = this,
      props = this.props,
      state = this.state;
    let status_messages = state.status_messages;
    delete status_messages[name];
    if ([true, 'true'].includes(value)) {
      component.setState({
        [name]: value,
        info: undefined,
        error: undefined,
        warning: undefined,
        status_messages: status_messages
      });
    } else {
      delete state[name];
      component.setState({
        info: undefined,
        error: undefined,
        warning: undefined,
        status_messages: status_messages
      });
    }
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const status = (0, _getFormStatus.default)(state);
    const loader = state.loading === true ? /*#__PURE__*/_react.default.createElement(_Loader.default, {
      className: "c-loader",
      bemit: ['white', 'bg-carbon']
    }) : undefined;
    const action_button = /*#__PURE__*/_react.default.createElement(_Button.default, {
      onClick: component.handleOk,
      className: "c-flat-btn",
      color: "primary"
    }, "Mettre \xE0 jour le statut");
    const output = /*#__PURE__*/_react.default.createElement(_Modal.default, {
      open: props.open,
      onClose: props.onClose,
      title: "Gestion du suivi du compte candidat",
      "scroll-area": ".back-page",
      bemit: ['medium', 'simple', 'monitoring', 'allow-overflow'],
      "close-label": "FERMER",
      "action-buttons": action_button,
      src: props.trigger_src,
      "close-classes": "c-flat-btn c-flat-btn--red u-margin-right-10"
    }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      container: true,
      spacing: 24,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 6,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Select.default, {
      onChange: component.handleChange,
      value: state.chosen_status,
      name: "chosen_status",
      label: "",
      status: state.status_messages,
      options: _options.default.account_status_options,
      "default-value": _options.default.account_status_options[0]?.value
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 6,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
      onChange: component.handleCheckboxChange,
      label: "Envoyer un commentaire par mail",
      name: "send_mail",
      value: state.send_mail === true,
      status: state.status_messages
    })), state.send_mail === true ? /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
      label: "Commentaire",
      onChange: component.handleChange,
      multiline: true,
      rows: "6",
      value: state['comment_status'],
      name: "comment_status",
      status: state.status_messages
    })) : undefined), loader);
    return output;
  }
}
var _default = exports.default = AccountStatusModal;
